import { Pipe, PipeTransform } from '@angular/core';

/**
 * TaxID pipe transforms a value into a tax ID format specified by XX-XXXXXXX
 */
@Pipe({
  name: 'taxId',
  standalone: true
})
export class TaxIdPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    // Return a string of less than length 2 as a plain string
    if (value.length <= 2) {
      return value;
    }

    // Otherwise, put a hyphen after the second character
    value = value.replace(/-/g, '');
    return value.slice(0, 2) + '-' + value.slice(2);
  }

}
